import React, { useEffect, useState } from "react";
import styles from "./ProgressBar.module.css";

const ProgressBar = ({ step, totalSteps = 4, progress }) => {
  // `progress` is the original percentage API. Callers that still pass it get
  // the same four-segment bar as before, so they need no change.
  const currentStep =
    step ?? Math.round((progress ?? 0) / (100 / totalSteps));

  // Start a segment behind so the current one animates in on mount — the same
  // trick the old `progress - 25` did, expressed in steps so it works for any
  // segment count.
  const [animatedStep, setAnimatedStep] = useState(currentStep - 1);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAnimatedStep(currentStep);
    }, 100);
    return () => clearTimeout(timeout);
  }, [currentStep]);

  return (
    <div
      className={`${styles.progressBarContainer} ${styles[`count${totalSteps}`]}`}
    >
      {Array.from({ length: totalSteps }, (_, index) => (
        <div
          key={index}
          className={`${styles.segment} ${styles[`segment${index + 1}`]} ${
            index < animatedStep ? styles.completed : ""
          }`}
        />
      ))}
    </div>
  );
};

export default ProgressBar;
